'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _UICardHeader = require('./UICardHeader');

var _UICardHeader2 = _interopRequireDefault(_UICardHeader);

var _UICardSection = require('./UICardSection');

var _UICardSection2 = _interopRequireDefault(_UICardSection);

var _UISection = require('../section/UISection');

var _UISection2 = _interopRequireDefault(_UISection);

var _UIDragHandle = require('../draggable/UIDragHandle');

var _UIDragHandle2 = _interopRequireDefault(_UIDragHandle);

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _AccordionTransition = require('../transitions/AccordionTransition');

var _AccordionTransition2 = _interopRequireDefault(_AccordionTransition);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _times = require('HubStyleTokens/times');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var TRANSITION_ANIMATION_TIMEOUT = parseInt(_times.CARD_TRANSITION_ANIMATION_TIMING, 10);

var isDraggable = function isDraggable(child) {
  return child.type.displayName === _UIDragHandle2.default.displayName;
};

var isExpander = function isExpander(child) {
  var possibleHeader = child;
  if (_react2.default.isValidElement(child) && isDraggable(child)) {
    possibleHeader = child.props.children;
  }

  return _react2.default.isValidElement(possibleHeader) && possibleHeader.type === _UICardHeader2.default;
};

var isSection = function isSection(child) {
  return _react2.default.isValidElement(child) && child.type === _UICardSection2.default;
};

var renderExpandableChildren = function renderExpandableChildren(children, expanded, onExpandedChange) {
  var sawHeader = false;
  var output = _react.Children.map(children, function (child) {
    if (isExpander(child)) {
      sawHeader = true;
      return _react2.default.cloneElement(child, { expanded: expanded, onExpandedChange: onExpandedChange });
    }

    if (isSection(child)) {
      return _react2.default.createElement(
        _AccordionTransition2.default,
        {
          className: 'private-card__content-wrapper',
          open: expanded,
          duration: TRANSITION_ANIMATION_TIMEOUT
        },
        child
      );
    }

    return child;
  });

  if (!sawHeader) {
    var msg = 'UICardWrapper: Expandable behavior requires a UICardHeader child';
    _devLogger2.default.warn({ message: msg, key: msg });
  }

  return output;
};

var UICardWrapper = _react2.default.createClass({
  displayName: 'UICardWrapper',

  propTypes: _extends({}, _UISection2.default.propTypes, {
    children: _react.PropTypes.node.isRequired,
    compact: _react.PropTypes.bool.isRequired,
    expanded: _react.PropTypes.bool,
    expandable: _react.PropTypes.bool,
    onExpandedChange: _react.PropTypes.func
  }),

  getDefaultProps: function getDefaultProps() {
    return _extends({}, _UISection2.default.defaultProps, {
      compact: false,
      expandable: false,
      expanded: true
    });
  },
  render: function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        compact = _props.compact,
        expandable = _props.expandable,
        expanded = _props.expanded,
        onExpandedChange = _props.onExpandedChange,
        rest = _objectWithoutProperties(_props, ['children', 'className', 'compact', 'expandable', 'expanded', 'onExpandedChange']);

    return _react2.default.createElement(
      _UISection2.default,
      _extends({}, rest, {
        className: (0, _classNames2.default)('private-card', 'private-card__wrapper', {
          'private-card--compact': compact
        }, className)
      }),
      expandable ? renderExpandableChildren(children, expanded, onExpandedChange) : children
    );
  }
});

exports.default = (0, _Controllable2.default)(UICardWrapper, ['expanded']);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/card/UICardWrapper.js
// module id = 372
// module chunks = 3 4